import React from 'react';
import {Slider, makeStyles, withStyles} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';

import type {SlideProps} from '@material-ui/core';
import ZoomInIcon from '../icons/ZoomInIcon';
import ZoomOutIcon from '../icons/ZoomOutIcon';

type Props = SlideProps;

const CustomSlider = withStyles({
  root: {
    color: colors.primary,
    height: 4,
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -7,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: '.75rem',
    fontSize: '2rem',
  },
}));

export default function ZoomSlider(props: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ZoomOutIcon />
      <CustomSlider {...props} />
      <ZoomInIcon />
    </div>
  );
}
